import "../css/salepoint.css";
import PageHeader from "../components/salepoint/PageHeader";
import InfoHeader from "../components/salepoint/InfoHeader";
import ReceiveGiven from "../components/salepoint/ReceiveGiven";
import Table from "../components/salepoint/Table";
import useCustomers from "../hook/useCustomers";
import { useEffect, useState } from "react";
import { getTxSerialNumber } from "../services/transactionService";

export default function SalePoint() {
  const { customers } = useCustomers();
  const [customer, setCustomer] = useState(null);
  const [serialNumber, setSerialNumber] = useState("-");

  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [time, setTime] = useState(() => {
    const now = new Date();
    return now.toTimeString().slice(0, 5);
  });

  useEffect(() => {
    getSerialNumberNew();
  }, []);

  const resetSerialNumber = () => {
    getSerialNumberNew();
    setCustomer(null);
  };

  const getSerialNumberNew = async (customerId) => {
    try {
      const response = await getTxSerialNumber();
      if (response.success) {
        setSerialNumber(response.serialNumber);
      }
    } catch (err) {
      console.log("ERR in sr.");
    }
  };

  return (
    <>
      <PageHeader />
      {/* Info Row */}
      <InfoHeader
        customers={customers}
        selectedCustomer={customer}
        setCustomer={setCustomer}
        serialNumber={serialNumber}
        date={date}
        setDate={setDate}
        time={time}
        setTime={setTime}
      />
      {/* Recive and given */}
      <ReceiveGiven
        customer={{
          customerId: customer?._id || "",
          customerName: customer?.name || "",
          customerAddress: customer?.address,
          customerContact: customer?.phone,
          setting: customer?.setting,
        }}
        serialNumber={serialNumber}
        date={date}
        time={time}
        resetSerialNumber={resetSerialNumber}
      />
      {/* <Table /> */}
      <div id="sidebarOverlay" />
    </>
  );
}
